module.exports = __webpack_public_path__ + "img/background.b7393cd.png";